import { useHistory } from "react-router-dom";
import images from "../../../../../../../../../utilities/images/images";
import userActivityActions from "../../../../../../../../../redux/user_activity/action";

import "./StoreSubjects.scss";
import { useDispatch } from "react-redux";

export const StoreSubjects = (props) => {
  const { packageData } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const setSubjectData = (data) => {
    dispatch(
      userActivityActions.setSubjectData({
        subjectId: data.sub_id,
        subjectName: data.sub_name,
        subjectIcon: data.icon,
      })
    );
    history.push("/subject_component");
  };
  return (
    <div className="login-subject-tab-container">
      {packageData?.map((sub) => (
        <div
          key={sub.sub_id}
          className="single-sub"
          style={{ background: sub.color }}
          onClick={() => setSubjectData(sub)}
        >
          <div className="sub-content">
            <img className="sub-image" src={sub.icon} alt="subject icon" />
            <div>
              <div className="subname">{sub.subject_name}</div>
              <div className="subtopics">{sub.total_topics} topics</div>
            </div>
          </div>
          <img
            className="arrw-image"
            src={images.storeRightArrow}
            alt="arrow"
          />
        </div>
      ))}
    </div>
  );
};
